// T2/100A01: Rutas del módulo Gestion Compras. Entry.js las agrega a su
// lista de páginas; cada pantalla se carga bajo demanda.
import React, { lazy, Suspense } from "react";
import { pathGestionCompras } from "Path/index";
// T2/100A73
import { COMPRAS_BODEGAS_V2 } from "config/featureFlags";
// T2/100A96: las URL del Compras original llevan al módulo nuevo.
import { Navigate } from "react-router-dom";
import { pathMaterial, pathWarehouse, pathTools } from "Path/index";

const PricebookPage = lazy(() => import("./pricebook/pages/PricebookPage"));
const GroupListModal = lazy(() => import("./pricebook/components/groups/GroupListModal"));
const GroupFormModal = lazy(() => import("./pricebook/components/groups/GroupFormModal"));
// T2/100A35: facturas de compra.
const InvoiceListPage = lazy(() => import("./facturas/pages/InvoiceListPage"));
const InvoiceFormPage = lazy(() => import("./facturas/pages/InvoiceFormPage"));
// T2/100A40: consumo por orden y desperdicio.
// T2/100A151: módulo "Consumo y desperdicio" retirado por orden del usuario (2026-10-28; minuta, tarea 18). Antes:
// const ConsumptionPage = lazy(() => import("./consumos/pages/ConsumptionPage"));
// T2/100A73: bodegas.
const WarehousesPage = lazy(() => import("./bodegas/pages/WarehousesPage"));
// T2/100A97: spend plan v2.
const SpendPlanPage = lazy(() => import("./spendplan/pages/SpendPlanPage"));
// T2/100A99: herramientas v2.
const ToolsPage = lazy(() => import("./herramientas/pages/ToolsPage"));
// T2/100A198: proveedores.
const SuppliersPage = lazy(() => import("./proveedores/pages/SuppliersPage"));
// T2/100A217: inventario y kardex.
const InventoryPage = lazy(() => import("./inventario/pages/InventoryPage"));
// T2/100A218: reportes en página completa.
const PricebookReportsPage = lazy(() => import("./reportes/pages/PricebookReportsPage"));

// Las ventanas cargan dentro de su propio Suspense para no ocultar la página
// de fondo mientras llega su código.
const modal = (element) => <Suspense fallback={null}>{element}</Suspense>;

export const gestionComprasRoutes = [
  {
    path: pathGestionCompras.pricebook,
    element: <PricebookPage />,
    children: [
      {
        path: "groups",
        element: modal(<GroupListModal />),
        children: [
          { path: "add", element: modal(<GroupFormModal />) },
          { path: "edit/:material_group_id", element: modal(<GroupFormModal />) },
        ],
      },
    ],
  },
  // T2/100A35: "nueva" va antes de ":invoice_id" (react-router prioriza la ruta fija igual).
  { path: pathGestionCompras.invoices, element: <InvoiceListPage /> },
  // T2/100A201: "Registrar factura" es la carga automática del Price book (usuario 2026-10-29); la URL
  // vieja lleva allá. Antes: { path: pathGestionCompras.invoiceNew, element: <InvoiceFormPage /> },
  { path: pathGestionCompras.invoiceNew, element: <Navigate to={pathGestionCompras.pricebook} replace /> },
  { path: pathGestionCompras.invoiceEdit, element: <InvoiceFormPage /> },
  // T2/100A40
  // T2/100A151: la URL vieja lleva al Price book. Antes: { path: pathGestionCompras.consumptions, element: <ConsumptionPage /> },
  { path: pathGestionCompras.consumptions, element: <Navigate to={pathGestionCompras.pricebook} replace /> },
  // T2/100A73: solo con REACT_APP_COMPRAS_BODEGAS_V2=true (sin la variable, igual que antes).
  ...(COMPRAS_BODEGAS_V2 ? [{ path: pathGestionCompras.warehouses, element: <WarehousesPage /> }] : []),
  // T2/100A97
  { path: pathGestionCompras.spendPlan, element: <SpendPlanPage /> },
  // T2/100A99
  { path: pathGestionCompras.tools, element: <ToolsPage /> },
  // T2/100A198
  { path: pathGestionCompras.suppliers, element: <SuppliersPage /> },
  // T2/100A217
  { path: pathGestionCompras.inventory, element: <InventoryPage /> },
  // T2/100A218
  { path: pathGestionCompras.pricebookReports, element: <PricebookReportsPage /> },
];

// T2/100A96: Compras original retirado. Sus URL del Price book y de Bodegas llevan a las nuevas.
// Entry.js las pone ANTES de sus rutas (con la misma ruta, react-router usa la primera).
const to = (path) => <Navigate to={path} replace />;
export const legacyComprasRedirects = [
  { path: pathMaterial, element: to(pathGestionCompras.pricebook) },
  { path: `${pathMaterial}/groups`, element: to(pathGestionCompras.pricebookGroups) },
  { path: `${pathMaterial}/groups/add`, element: to(`${pathGestionCompras.pricebookGroups}/add`) },
  { path: `${pathMaterial}/groups/edit/:material_group_id`, element: to(pathGestionCompras.pricebookGroups) },
  { path: pathWarehouse, element: to(pathGestionCompras.warehouses) },
  // T2/100A99: Herramientas del legado → Herramientas v2 (la Asignación sigue en Talento Humano).
  { path: pathTools, element: to(pathGestionCompras.tools) },
];
